<!--
 * @Author: 71
 * @Date: 2026-06-12 15:16:36
 * @LastEditTime: 2026-06-15 14:11:15
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\views\school\AppPage\ HundredDayOath\compoents\model\ActivityEmotionSpaceSection1.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <div class="container">
    <div class="content">
      <!-- 第一部分：学校管理 -->
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="24" class="title-1 title-margin flex-between">
          <div>学校试用情况：</div>
        </a-col>
      </a-row>
      <a-card :bordered="true">
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            :rowKey="(record, index) => index + '_' + record.id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <template slot="freeOpenSlot" slot-scope="text, record">
              <a-switch :checked="!!text" @change="changetrialOpenFlag(record.id, text)"/>
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>
            </span>
          </a-table>
        </div>
        <!-- table区域-end -->
      </a-card>
      <!-- 弹窗区域 -->
      <school-config-modal ref="modalForm" @ok="modalFormOk"></school-config-modal>
    </div>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction } from '@/api/manage'
import { copyText } from '@/utils/util'
import SchoolConfigModal from './SchoolConfigModal.vue'
import { message } from 'ant-design-vue'
export default {
  name: 'ActivityEmotionSpacePaneSection1',
  mixins: [JeecgListMixin],
  components: {
    SchoolConfigModal,
  },
  data() {
    return {
      tenantList: [],
      // 表头
      columns: [
        {
          title: '#序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return (this.ipagination.current - 1) * this.ipagination.pageSize + parseInt(index) + 1
          }.bind(this),
        },
        {
          title: '学校',
          align: 'center',
          dataIndex: 'schoolName',
        },
        {
          title: '试用天数',
          align: 'center',
          width: 220,
          dataIndex: 'days',
        },
        {
          title: '会员权限是否开启', // (1-微信支付 2-支付宝支付)
          align: 'center',
          dataIndex: 'trialOpenFlag',
          width: 220,
          scopedSlots: { customRender: 'freeOpenSlot' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 220,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      url: {
        list: '/schoolTrialMemberConfig/list', // 免费情绪空间开启列表, 2026-06-12，露冰新增
        edit: '/schoolTrialMemberConfig/edit', // 更新单条记录
        add: '/schoolTrialMemberConfig/add', // 新增单条记录
      },
    }
  },
  created() {
    this.loadTenantList() // 获取学校列表
  },
  methods: {
    // 请求获取学校列表
    loadTenantList() {
      // 获取学校列表， 老订单接口，非新增
      getAction('/sys/tenant/list', {
        pageNo: 1,
        pageSize: 1000, //TODO 暂时放大单页查询量1000
        order: 'desc',
      }).then((res) => {
        console.log(res)
        if (res.success) {
          let records = res.result?.records;
          if (records) {
            records.sort((a,b) => a.name.localeCompare(b.name, 'zh-CN'));
            this.tenantList = records;
          }
        }
      })
    },
    // 请求更新是否开放免费试用
    changetrialOpenFlag(recordId, trialOpenFlag) {
      let params = {
        id: recordId,
        trialOpenFlag: !trialOpenFlag ? 1 : 0,
      }
      console.log(params)
      postAction(this.url.edit, params).then((res) => {
        message.success({ content: '更新成功!', duration: 1 })
        console.log(res)
        this.loadData()
      })
    },
    // 重写混入方法
    handleAdd: function () {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.tenantList = this.tenantList // 学校列表带进去
      this.$refs.modalForm.disableSubmit = false
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.tenantList = this.tenantList // 学校列表带进去
      this.$refs.modalForm.disableSubmit = false
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
